exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-group-override {\n    padding-left: 170px !important;\n}\n\n.form-group-label-override {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.sub-label-for-input {\n    position: absolute;\n    top: 26px;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    left: 170px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common.css
// module id = 136
// module chunks = 0